import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarItemContextMenu"*/ './lazyIndex')
);

/**
 * Lazily load and call hiding the item context menu
 */
export let lazyHideItemContextMenu = new LazyAction(lazyModule, m => m.hideItemContextMenu);

/**
 * Lazily load and call showing the item context menu
 */
export let lazyShowItemContextMenu = new LazyAction(lazyModule, m => m.showItemContextMenu);

/**
 * Lazily load and call hiding the surface context menu
 */
export let lazyHideSurfaceContextMenu = new LazyAction(lazyModule, m => m.hideSurfaceContextMenu);

/**
 * Lazily load and call showing the surface context menu
 */
export let lazyShowSurfaceContextMenu = new LazyAction(lazyModule, m => m.showSurfaceContextMenu);

// NOTE: these non-lazy actions are for subscription purposes only; do not invoke
export { default as showItemContextMenu } from './actions/showItemContextMenu';
export { default as hideItemContextMenu } from './actions/hideItemContextMenu';
export { default as hideSurfaceContextMenu } from './actions/hideSurfaceContextMenu';
export { default as showSurfaceContextMenu } from './actions/showSurfaceContextMenu';
